// extracted by mini-css-extract-plugin
export var blue = "_4h-h";
export var brand = "_4h-d";
export var darkGrey = "_4h-g";
export var disabled = "_4h-6";
export var disabledSubtle = "_4h-7";
export var error = "_4h-8";
export var green = "_4h-i";
export var grey = "_4h-f";
export var icon = "_4h-0";
export var inherit = "_4h-c";
export var lightGrey = "_4h-e";
export var orange = "_4h-k";
export var pink = "_4h-m";
export var primary = "_4h-1";
export var purple = "_4h-n";
export var quaternary = "_4h-4";
export var quinary = "_4h-5";
export var red = "_4h-l";
export var secondary = "_4h-2";
export var success = "_4h-b";
export var tertiary = "_4h-3";
export var warning = "_4h-9";
export var warningSecondary = "_4h-a";
export var white = "_4h-o";
export var yellow = "_4h-j";